import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export default function Lightbox({ src, alt, onClose }) {
  return (
    <AnimatePresence>
      {src && (
        <motion.div
          className="fixed inset-0 z-[80] bg-black/90 backdrop-blur-sm flex items-center justify-center p-6 md:p-16"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          data-testid="lightbox"
        >
          <button
            onClick={onClose}
            aria-label="Close"
            data-testid="lightbox-close"
            className="absolute top-6 right-6 text-ivory/80 hover:text-gold transition-colors duration-300"
          >
            <X className="w-8 h-8" strokeWidth={1.25} />
          </button>
          <motion.img
            src={src}
            alt={alt}
            initial={{ scale: 0.95 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.95 }}
            transition={{ duration: 0.3 }}
            onClick={(e) => e.stopPropagation()}
            className="max-w-full max-h-full object-contain rounded-sm shadow-2xl"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
